import api from '@/api';

export const actions = {

    adminUserSave({dispatch}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            let url = 'users/admin';
            let method = 'POST';
            if(data.id) {
                url += '/' + data.id;
                method = 'PUT'
            }

            api({url: url, data: data, method: method})
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        })
    },

};
